<template>
    <textfield-screen
                      :placeholder="$ml.get('setBirthdayPlaceholderReg')"
                      id="birthday"
                      :title="$ml.get('setBirthdayTitleReg')"
                      input-type="calendar"
                      :defaultValue="defaultValue"
                      :isNotValid="isError"
                      :isNotValidMessage="errorMessageText"
                      :disabledNextButton="isLoading"
                      :headerImg="2"
                      @next="next"
                      @back="back"
    ></textfield-screen>
</template>

<script>
    import Profile from '../../helpers/profile'
    import {
        getRecoveryContacts as apiGetRecoveryContacts,
        registerProfile as apiRegisterProfile,
        getApiErrorMessage
    } from '../../helpers/api'
    import TextfieldScreen from "../../components/layout/textfield-screen";
    export default {
        name: "setBirthdayPage",
        components: {TextfieldScreen},
        data () {
            return {
                defaultValue: Profile.birthdayDate ? this.$moment(Profile.birthdayDate).format('DD/MM/YYYY') : '',
                isError: false,
                errorMessageText: '',
                isErrorTimeout: null,
                isLoading: false,
            }
        },
        methods: {
            next: function (data) {
                if (this.isLoading)
                    return;
                let date = this.$moment(data.value, 'DD/MM/YYYY');
                let years = this.$moment().diff(date.format('YYYY-MM-DD'), 'years');
                if (years < 14 || years > 100) {
                    this.showError(this.$ml.get('birthdayError'));
                    return;
                }
                Profile.setData({birthdayDate: date.format()});
                this.isLoading = true;
                if (Profile.process === 'accessRecovery') {
                    apiGetRecoveryContacts().then(() => {
                        if (Object.keys(Profile.recoveryContacts).length > 0)
                            this.$router.push({name: 'AccessRecoveryInfoSelectLogin'});
                        else
                            this.$router.push({ name: 'AccessRecoveryInfoSelectLoginError'});
                    }, err => {
                        let message = '';
                        switch (err.status) {
                            case 404: this.$router.push({ name: 'AccessRecoveryInfoSelectLoginError'}); break;
                            default: message = getApiErrorMessage(err);
                        }
                        this.showError(message);
                    }).finally(()=>{
                        this.isLoading = false;
                    });
                } else {
                    apiRegisterProfile().then(()=>{
                        this.$router.push({name: 'RegistrationInfoPinCodePage'});
                    }, err => {
                        let message = '';
                        switch (err.status) {
                            case 405: this.$router.push({name: 'RegistrationInfoPinCodePage'}); return;
                            case 406: this.$router.push({name: 'RegistrationUserAlreadyExist'}); return;
                            default: message = getApiErrorMessage(err);
                        }
                        this.showError(message);
                    }).finally(()=>{
                        this.isLoading = false;
                    })

                }
            },
            back: function () {
                this.$router.back();
            },

            showError: function (message) {
                this.errorMessageText = message;
                this.isError = true;
                clearTimeout(this.isErrorTimeout);
                this.isErrorTimeout = setTimeout(() => {
                    this.errorMessageText = '';
                    this.isError = false;
                }, 3000);
            },
        },
    }
</script>

<style scoped>

</style>